var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 22,
    viewBox: "0 0 12 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 5L10 16.5C10 18.71 8.21 20.5 6 20.5C3.79 20.5 2 18.71 2 16.5L2 4C2 2.62 3.12 1.5 4.5 1.5C5.88 1.5 7 2.62 7 4L7 14.5C7 15.05 6.55 15.5 6 15.5C5.45 15.5 5 15.05 5 14.5L5 5H3.5L3.5 14.5C3.5 15.88 4.62 17 6 17C7.38 17 8.5 15.88 8.5 14.5V4C8.5 1.79 6.71 0 4.5 0C2.29 0 0.5 1.79 0.5 4L0.5 16.5C0.5 19.54 2.96 22 6 22C9.04 22 11.5 19.54 11.5 16.5L11.5 5H10Z",
    fill: "#585A64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinImg);
export default __webpack_public_path__ + "static/media/pinImg.31ba17f8c1f092e37edcc79e5cbfe407.svg";
export { ForwardRef as ReactComponent };